import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ACTLogoA from "../assets/images/ACT-A-logo.png";
import ACTButton from "./ACTButton";
import { AppContext } from "../context/AppContext";
import TimerVerified from "../TimerVerified";
import toggleVisibilityRef from "./ToggleVisibilityRef";

const VerifiedPanel = ({ goToEndPanel }) => {
  const { validationStatus, setShowWebPage } = useContext(AppContext);
  const [accountIdEntered, setAccountIdEntered] = useState("");
  const timerRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [visible, setVisible] = useState(toggleVisibilityRef.isVisible);

  const goToWhat = () => {
    console.log("What does this mean?");
  };

  const onTextEnter = (text) => {
    setAccountIdEntered(text);
  };

  const handleTimerExpire = () => {
    if (goToEndPanel) goToEndPanel();
  };

  useEffect(() => {
    const unsubscribe = toggleVisibilityRef.subscribe(setVisible);
    return unsubscribe;
  }, []);

  return (
    <Box>
      <img
        src={ACTLogoA}
        alt="ACT logo"
        style={{
          width: isMobile ? "6rem" : "6rem",
          height: "auto",
          marginLeft: "2rem",
          marginTop: "-1.5rem",
          imageRendering: "crisp-edges",
        }}
      />
      <Typography
        sx={{
          maxWidth: "14rem",
          fontSize: "1.1rem",
          fontWeight: "500",
          lineHeight: "1.1",
          margin: isMobile
            ? "1rem auto 1.5rem auto"
            : "0.5rem auto 0.8rem auto",
        }}
      >
        Welcome back.
        <br />
        Your browser location has been{" "}
        <span style={{ color: "#E54F9C" }}>Verified</span>
      </Typography>

      <Typography
        sx={{
          maxWidth: "12.5rem",
          fontSize: "0.9rem",
          fontWeight: "500",
          lineHeight: "1.2",
          margin: "0.3rem auto 0 auto",
        }}
      >
        Your session will expire in:
      </Typography>
      {validationStatus && validationStatus.expiryTime && (
        <TimerVerified
          ref={timerRef}
          expiryTime={validationStatus.expiryTime}
          onExpire={handleTimerExpire}
        />
      )}
      <Tooltip
        title="Time allowed to use site"
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -10],
                },
              },
            ],
          },
        }}
      >
        <button onClick={goToWhat}>
          <Typography
            sx={{
              maxWidth: "12.5rem",
              fontSize: "0.8rem",
              fontWeight: "500",
              margin: "0.5rem auto 0 auto",
              color: "#000000",
              textDecoration: "underline",
              cursor: "pointer",
              "&:hover": {
                opacity: "0.65",
              },
            }}
          >
            What does this mean?
          </Typography>
        </button>
      </Tooltip>
      <Box
        sx={{
          width: "17rem",
          margin: "1rem auto 0 auto",
        }}
      >
        <ACTButton
          content="Continue"
          onClick={() => toggleVisibilityRef.toggle()}
          bgColor="#E54F9C"
          textColor="#ffffff"
          hoverColor=" #b33b78"
          hoverTextColor="#ffffff"
          border="0.1rem solid #E54F9C"
          hoverBorder="0.1rem solid #b33b78"
        />
      </Box>
    </Box>
  );
};

export default VerifiedPanel;
